import { createClient } from '@supabase/supabase-js';

import { createAuthDeadlineFetch } from './auth-fetch';
import { env } from './env';
import { catchRecoveryLink } from './recovery-redirect';

// MUST stay above createClient(). The client starts consuming the auth fragment
// as soon as it is constructed and then strips it from the URL, so a recovery
// link that landed on the wrong path has to be rerouted before that happens.
catchRecoveryLink();

export const supabase = createClient(env.SUPABASE_URL, env.SUPABASE_PUBLISHABLE_KEY, {
  // supabase-js sets no fetch timeout anywhere, so a hung auth request is
  // waited on forever. This bounds ONLY /auth/v1/ — uploads and Edge Functions
  // keep their unlimited budget. See lib/auth-fetch.ts.
  global: { fetch: createAuthDeadlineFetch() },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Required by the Google sign-in redirect: the browser returns to
    // /auth/callback carrying a PKCE code, and this is what exchanges it for a
    // session. See features/auth/AuthCallbackPage.
    detectSessionInUrl: true,
  },
});
